import { cn } from '@lyearn/style';

import { GroupImageClassOverries } from '../types';
import { imageBorderStyles } from './styles';

// TODO: check if can create emotion class
export const GROUP_IMAGE_CLASSES = {
  compact: {
    userCollection: {
      root: 'w-40',
      firstPicture: 'w-24 h-24 bg-s-info-light text-s-info-light',
      firstPictureSize: 24,
      secondPicture:
        'w-28 h-28 absolute start-14 -top-2 border-2 bg-s-info-light text-s-info-light border-text-white group-hover:border-bg-secondary',
      secondPictureSize: 28,
    },
    contentCollection: {
      root: 'w-40',
      firstPicture: 'w-24 h-24 bg-s-info-light rounded-4',
      firstPictureSize: 24,
      secondPicture:
        'w-28 h-28 absolute start-10 -top-2 border-2 border-text-white group-hover:border-bg-secondary bg-s-info-light rounded-4',
      secondPictureSize: 28,
    },
  } as GroupImageClassOverries,
  normal: {
    userCollection: {
      root: 'w-48 h-48',
      firstPicture: 'w-32 h-32 bg-s-info-light text-s-info-light',
      firstPictureSize: 32,
      secondPicture:
        'w-36 h-36 absolute start-14 top-14 border-2 border-text-white group-hover:border-bg-secondary bg-s-info-light text-s-info-light',
      secondPictureSize: 36,
    },
    contentCollection: {
      root: 'w-48 h-48',
      firstPicture: cn(
        imageBorderStyles,
        'absolute top-0 start-0 w-38 h-38 bg-s-info-light rounded-4',
      ),
      firstPictureSize: 38,
      secondPicture: cn(
        imageBorderStyles,
        'w-38 h-38 absolute start-10 top-10 group-hover:border-bg-secondary bg-s-info-light rounded-4',
      ),
      secondPictureSize: 38,
    },
  } as GroupImageClassOverries,
  'normal-small': {
    userCollection: {
      root: 'w-42 h-42',
      firstPicture: 'w-28 h-28 bg-s-info-light text-s-info-light',
      firstPictureSize: 28,
      secondPicture:
        'w-32 h-32 absolute start-12 top-12 border-2 border-text-white group-hover:border-bg-secondary bg-s-info-light text-s-info-light',
      secondPictureSize: 32,
    },
    contentCollection: {
      root: 'w-42 h-42',
      firstPicture: cn(
        imageBorderStyles,
        'absolute top-0 start-0 w-36 h-36 bg-s-info-light rounded-4',
      ),
      firstPictureSize: 36,
      secondPicture: cn(
        imageBorderStyles,
        'w-36 h-36 absolute start-10 top-10 group-hover:border-bg-secondary bg-s-info-light rounded-4',
      ),
      secondPictureSize: 36,
    },
  } as GroupImageClassOverries,
};
